<template>
  <GeneralAnalytics :store="selectedStore" />
</template>

<script>
import GeneralAnalytics from "@/components/analytics/GeneralAnalytics";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    GeneralAnalytics,
  },

  computed: {
    ...mapGetters("store", ["selectedStore"]),
    ...mapGetters("auth", ["accessibleStoreIds"]),
  },

  watch: {
    accessibleStoreIds: {
      immediate: true,
      handler(storeIds) {
        if (Array.isArray(storeIds) && storeIds.length > 0) {
          this.fetchBusinessVerticals({ storeId: [storeIds[0]], enabled: true });
        }
      },
    },
  },

  methods: {
    ...mapActions("businessVerticals", { fetchBusinessVerticals: "fetchIndex" }),
  },
};
</script>
